import React, { useState } from 'react'

import { useTranslation } from 'react-i18next'

import CreateAccountForm from './CreateAccountForm'
import SignInForm from './SignInForm'

enum TabState {
  CREATE_ACCOUNT,
  SIGN_IN,
}

interface Props {
  purchaseQuantity: number
  titleId: string
}

const SignInRequired: React.FC<Props> = ({ purchaseQuantity, titleId }: Props) => {
  const { t } = useTranslation()

  const [tabState, setTabState] = useState(TabState.CREATE_ACCOUNT)

  return (
    <div className="flex flex-col">
      {tabState === TabState.CREATE_ACCOUNT && (
        <>
          <CreateAccountForm purchaseQuantity={purchaseQuantity} titleId={titleId} />
          <ToggleLink
            text={t('content.alreadyHaveAccount')}
            linkText={t('action.signIn')}
            action={() => setTabState(TabState.SIGN_IN)}
          />
        </>
      )}
      {tabState === TabState.SIGN_IN && (
        <>
          <SignInForm purchaseQuantity={purchaseQuantity} titleId={titleId} />
          <ToggleLink
            text={t('content.newToNoteflight')}
            linkText={t('action.createAnAccount')}
            action={() => setTabState(TabState.CREATE_ACCOUNT)}
          />
        </>
      )}
    </div>
  )
}

export default SignInRequired

interface ToggleLinkProps {
  text: string
  linkText: string
  action: () => void
}
const ToggleLink: React.FC<ToggleLinkProps> = ({ text, linkText, action }: ToggleLinkProps) => {
  return (
    <div className="w-full flex flex-row items-center justify-center mt-4">
      <p>{text}</p>
      <button type="button" className="orange-link ml-1" onClick={action}>
        {linkText}
      </button>
    </div>
  )
}
